import { createSlice } from '@reduxjs/toolkit';

import * as reducers from 'store/reducers/buyBarReducer';
import { IBuyBarState } from 'store/types/buyBarTypes';

export const initialState: IBuyBarState = {
  buyBarSizesMap: {},
  buyNewVariant: null,
  buyUsedVariant: null,
  expandedSize: null,
  makeOfferVariant: null,
  mobileBuyBarView: 'none',
  offersMap: null,
  variantGridView: 'none',
};

export const buyBarSlice = createSlice({
  name: 'buyBar',
  initialState,
  reducers,
});

export const {
  setBuyBarSizesMap,
  setBuyNewAndBuyUsedVariants,
  setExpandedSize,
  setMakeOfferVariant,
  setMobileBuyBarView,
  setOffersMap,
  setVariantGridView,
} = buyBarSlice.actions;
export default buyBarSlice.reducer;
